/**
 * Shared wardrobe CORNER GLYPH — the tick ("wearing now") mark. Used BOTH on the cosmetic tiles AND in the
 * {@link WardrobeLegend} so the key and the tiles show the SAME picture. Decorative (aria-hidden) — the
 * surrounding control/legend text carries the accessible meaning. The effort-currency (✨) glyph is NO longer
 * here: it is hero-SKINNED (ADR-0103) and resolved via `heroCurrencyFor` in `@/entities/hero`.
 */

/** The "wearing now" tick. */
export function CheckGlyph({ size = 12 }: { size?: number }): React.ReactElement {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
      <path
        d="M5 13l4 4 10-11"
        stroke="currentColor"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
